exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-email-form[data-v-1894fc68] {\n  margin-top: 20px;\n}\n", ""]);

// exports
